import axios from './axios';

export const getOrderItems = ({ params } = {}) => axios.get(`order_items`, { params });
export const getOrderItem = ({ id, params }) => axios.get(`order_items/${id}`, { params });
export const createOrderItem = ({ data }) => axios.post('order_items', data);
export const updateOrderItem = ({ id, data }) => axios.put(`order_items/${id}`, data);
export const deleteOrderItem = ({ id }) => axios.delete(`order_items/${id}`);